<div class="row">
	<div class="col-lg-4">
		<div class="panel constrain">
			<div class="heading">Regimes</div>
			<div class="content nopad">
				<table class="log openborders paneled regimes">
					<thead>
						<tr>
							<th># Acq</th>
							<th>Regime</th>
							<th>Evaluate</th>
						</tr>
					</thead>
					@for (regime of regimeCounts ?? []; track regime) {
					<tbody>
						<tr>
							<td>{{regime.count}}</td>
							<td>{{regime.name}}</td>
							<td class="center">
								<input type="checkbox" [(ngModel)]="regime.evaluate" (ngModelChange)="regimesChange()">
							</td>
						</tr>
					</tbody>
					}
					@if (regimeCounts === undefined) {
					<tbody>
						<tr>
							<td colspan="3" class="loading-status">
								<div class="logo-spin"></div>
								Loading regimes...
							</td>
						</tr>
					</tbody>
					}
					@if (regimeCounts?.length === 0) {
					<tbody>
						<tr>
							<td colspan="3" class="loading-status">No regime data found</td>
						</tr>
					</tbody>
					}
				</table>
			</div>
		</div>
	</div><!-- End left column -->
	<div class="col-lg-8">
		<div class="panel">
			<div class="heading">Track Split</div>
			<div class="content">
				<app-dvs-chart [options]="timelineOptions" [height]="'300px'" [error]="(regimeCounts && regimeCounts.length === 0) ? 'No track data found' : undefined"
					[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
				@if (timelineOptions && adjustments && adjustments.length) {
				<div class="chart-legend">
					<span class="legend-item">
						<span class="swatch adjustment"></span> Adjustment (see below)
					</span>
				</div>
				}
			</div>
		</div>
	</div>
</div>
<div class="panel">
	<div class="heading">Adjustment History</div>
	<div class="content nopad">
		@if (adjustments && !adjustments.length) {
		<div class="p-3">
			No adjustments have been recorded for this rotor
		</div>
		}
		@if (adjustments && adjustments.length) {
		<div>
			<div class="p-3">Rotor blades: {{blades}}</div>
			<table class="log openborders paneled adjustment-history">
				<thead>
					<tr>
						<th>Operation</th>
						<th>Entered by</th>
						@for (adjdef of rotor.adjdef; track adjdef) {
						<th>{{adjdef.name}}</th>
						}
						<th>User note</th>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<th>
							Delete</th>
						}
					</tr>
				</thead>
				@for (adjustment of adjustments; track adjustment) {
				<tbody>
					<tr>
						<td>{{adjustment.operation_start_time | datetime : "offset" : (fleet ? fleet.time_offset_hours : 0) }}</td>
						<td>{{adjustment.author_email}}</td>
						@for (row of adjustment.adjustments.split('|'); track row) {
						<td>{{row | commalist}}</td>
						}
						<td [title]="adjustment.user_note"><span>{{adjustment.user_note}}</span></td>
						@if (api.user.role === 'orgadmin' || api.user.role === 'admin' || api.user.role === 'master') {
						<td>
							<app-action-button [action]="DeleteAdjustment" [args]="[adjustment.adjustment_history_id]" [context]="this" btnClass="icon red" confirm="Are you sure?"
								processing="..."><i class="icon-trash"></i></app-action-button>
						</td>
						}
					</tr>
				</tbody>
				}
			</table>
		</div>
		}
	</div>
</div>